import instanceQuery from '../../queries/customer/CustomerConfigQuery.graphql';
import defaultQuery from '../../queries/customer/CustomerConfigDefault.graphql';
import mutationQuery from '../../mutations/customer/CustomerConfigMutation.graphql';
import fragment from '../../fragments/customer/CustomerConfigFragment.graphql';
import { ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const CustomerConfig: EntityType = {
  type: 'CustomerConfig',
  title: 'Customer Configuration',
  formTitle: 'Customer Configuration',
  formUrl: '/Customers/CustomerConfig/',
  instance: instanceQuery,
  workspace: null,
  default: defaultQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'CUSTOMER_CONFIGURATION',
  operations: ALLOW_EDIT | ALLOW_VIEW,
};

export default CustomerConfig;
